import { DefaultValue } from "recoil";

export function isNotRecoilDefaultValue<T>(newValue: T | DefaultValue): newValue is T {
  return !(newValue instanceof DefaultValue);
}
